<template>
    <ModalBase :with-content="true" @close="close">
        <Loader :loading="loading"></Loader>
        <h1>{{ $t("preferences.title") }}</h1>
        <div class="preferences-users">
            <div class="ligne">
                <label>{{ $t("preferences.label.name") }} :</label> <input type="text" :value="currentUser.user.lastname" readonly />
            </div>
            <div class="ligne">
                <label>{{ $t("preferences.label.userName") }} :</label> <input type="text" :value="currentUser.user.firstname" readonly />
            </div>
        </div>
        <div class="preferences-select">
            <div class="ligne">
                <label>{{ $t("preferences.label.language") }} :</label>
                <select v-model="selectedLang">
                    <option class="extra-option" :value="LAST_VALUE">{{ $t("preferences.option.language") }}</option>
                    <option v-for="lang in getLangs" :value="lang.id" :key="lang.id" :selected="selectedLang === lang.id"> {{ lang.label }}</option>
                </select>
            </div>
            <div class="ligne">
                <label>{{ $t("preferences.label.brand") }} :</label>
                <select @change="brandChanged" v-model="selectedBrandId">
                    <option v-if="brandsList.length > 1" class="extra-option" :value="LAST_VALUE">{{ $t("preferences.option.brand") }}</option>
                    <option v-for="brand in brandsList" :value="brand.id" :key="brand.id" :selected="selectedBrandId === brand.id">
                        {{ brand.name }}
                    </option>
                </select>
            </div>
            <div class="ligne" v-show="aBrandIsSelected">
                <label>{{ $t("preferences.label.zoned") }} :</label>
                <select v-model="selectedZoneId">
                    <option class="extra-option" :value="-1">{{ $t("preferences.option.zoned") }}</option>
                    <option v-for="zone in zoneList" :value="zone.id" :key="zone.id" :selected="selectedZoneId === zone.id"> {{ zone.name }}</option>
                </select>
            </div>
            <div class="ligne" v-show="aBrandIsSelected">
                <label>{{ $t("preferences.label.stands") }} :</label>
                <select @change="standChanged" v-model="selectedStandId">
                    <option class="extra-option" :value="LAST_VALUE">{{ $t("preferences.option.stands") }}</option>
                    <option v-for="stand in standsList" :value="stand.id" :key="stand.id" :selected="selectedStandId === stand.id">
                        {{ stand.name }}
                    </option>
                </select>
            </div>
            <div class="ligne" v-show="aBrandIsSelected && aStandIsSelected">
                <label>{{ $t("preferences.label.campaign") }} :</label>
                <select v-model="selectedCampaignId">
                    <option class="extra-option" :value="LAST_VALUE">{{ $t("preferences.option.campaign") }}</option>
                    <option v-for="campaign in campaignsList" :value="campaign.id" :key="campaign.id" :selected="selectedCampaignId === campaign.id">
                        {{ campaign.name }}
                    </option>
                </select>
            </div>
        </div>
        <footer>
            <ClientColorButton @click="savePreferences">{{ $trad.common.save }}</ClientColorButton>
            <ClientColorButton @click="close" :inactive-color="true">{{ $trad.common.cancel }}</ClientColorButton>
        </footer>
    </ModalBase>
</template>

<script>
import { mapGetters } from "vuex";
import connectionBO from "../../../services/connectionBO";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import ClientColorButton from "@/components/ui/ClientColorButton";
import Loader from "@/components/loader/loader";
import ModalBase from "@/components/modal/ModalBase";
import cacheService from "@/services/cache";

const LAST_VALUE = -1;

export default {
    name: "preferences",
    props: ["action"],
    mixins: [TryLoadMixin],
    components: {
        ModalBase,
        ClientColorButton,
        Loader
    },
    data() {
        return {
            LAST_VALUE,
            selectedLang: undefined,
            selectedBrandId: undefined,
            selectedZoneId: undefined,
            selectedStandId: undefined,
            selectedCampaignId: undefined,
            zoneList: [],
            standsList: [],
            campaignsList: [],
            brandsList: [],
            prefRegistre: {}
        };
    },
    async created() {
        this.brandsList = this.currentUser.user.brands;
        this.loadPreferences();
    },
    methods: {
        close() {
            this.$emit("close");
        },
        async loadPreferences() {
            const response = await this.tryLoad(() => connectionBO.getPreferences());
            const { preference } = response;
            this.prefRegistre = response;
            const { language, brand, zone, stand, campaign } = preference;

            // We must check if the default value is 'null' or 'true' cause sometime the API return 'null' to mean 'false'
            this.selectedLang = language.default || language.default == null ? LAST_VALUE : language.id;
            this.selectedBrandId = brand.default || brand.default == null || !brand.id ? LAST_VALUE : brand.id;
            this.selectedZoneId = zone.default || zone.default == null ? LAST_VALUE : zone.id;
            this.selectedStandId = stand.default || stand.default == null ? LAST_VALUE : stand.id;
            this.selectedCampaignId = campaign.default || campaign.default == null ? LAST_VALUE : campaign.id;

            if (this.brandsList.length === 1) {
                this.selectedBrandId = this.brandsList[0].id;
            }

            if (this.aBrandIsSelected) {
                let currentBrand = this.brandsList.find(brand => brand.id === this.selectedBrandId);
                this.zoneList = currentBrand.zones;
                this.standsList = currentBrand.stands;
                this.campaignsList = currentBrand.campaigns;
            }
        },
        async savePreferences() {
            let { preference } = this.prefRegistre;
            preference.activated = true;
            //SET LANG
            preference.language.default = !this.aLangIsSelected;
            preference.language.id = this.aLangIsSelected ? this.selectedLang : cacheService.getUserLangId();

            /* Aucune marque n'est choisie donc les valeurs sont par défaut "Dernière valeur" */
            if (!this.aBrandIsSelected) {
                preference.brand.default = true;
                preference.zone.default = true;
                preference.stand.default = true;
                preference.campaign.default = true;
                preference.brand.id = this.currentUser.brandId;
                preference.zone.id = this.currentUser.zoneId;
                preference.stand.id = this.currentUser.standDesignId;
                preference.campaign.id = this.currentUser.campaignId;
            } else {
                preference.brand.default = false;
                preference.zone.default = !this.aZoneIsSelected;
                preference.stand.default = !this.aStandIsSelected;
                preference.campaign.default = !this.aCampaignIsSelected;
                preference.brand.id = this.selectedBrandId;

                if (parseInt(this.currentUser.brandId) !== this.selectedBrandId) {
                    const currentBrand = this.brandsList.find(brand => brand.id === this.selectedBrandId);
                    preference.zone.id = this.aZoneIsSelected ? this.selectedZoneId : currentBrand.zones[0].id;
                    preference.stand.id = this.aStandIsSelected ? this.selectedStandId : currentBrand.stands[0].id;
                    preference.campaign.id = this.aCampaignIsSelected ? this.selectedCampaignId : currentBrand.campaigns[0].id;
                } else {
                    /* La marque choisie est la même que la marque actuelle */
                    preference.stand.id = this.aStandIsSelected ? this.selectedStandId : this.currentUser.standDesignId;
                    preference.zone.id = this.aZoneIsSelected ? this.selectedZoneId : this.currentUser.zoneId;
                    preference.campaign.id = this.aCampaignIsSelected ? this.selectedCampaignId : this.currentUser.campaignId;
                }
            }
            if (preference) {
                this.prefRegistre.preference = preference;
                await this.tryLoad(() => connectionBO.postPreference(this.prefRegistre));
                this.dialogSuccess(this.$trad.preferences.successMessage);
                this.close();
            }
        },
        brandChanged() {
            if (this.aBrandIsSelected) {
                const currentBrand = this.brandsList.find(brand => brand.id === this.selectedBrandId);
                this.zoneList = (currentBrand && currentBrand.zones) || [];
                this.standsList = (currentBrand && currentBrand.stands) || [];
            }
            this.selectedZoneId = LAST_VALUE;
            this.selectedStandId = LAST_VALUE;
            this.selectedCampaignId = LAST_VALUE;
        },
        standChanged() {
            if (this.aStandIsSelected) {
                const selectedStand = this.standsList.find(stand => stand.id === this.selectedStandId);
                this.campaignsList = (selectedStand && selectedStand.campaigns) || [];
            }
            this.selectedCampaignId = LAST_VALUE;
        }
    },
    computed: {
        ...mapGetters("i18n", ["getLangs"]),
        ...mapGetters("currentUser", ["currentUser"]),
        aBrandIsSelected() {
            return this.selectedBrandId && this.selectedBrandId !== LAST_VALUE;
        },
        aStandIsSelected() {
            return this.selectedStandId && this.selectedStandId !== LAST_VALUE;
        },
        aCampaignIsSelected() {
            return this.aStandIsSelected && this.selectedCampaignId && this.selectedCampaignId !== LAST_VALUE;
        },
        aZoneIsSelected() {
            return this.selectedZoneId && this.selectedZoneId !== LAST_VALUE;
        },
        aLangIsSelected() {
            return this.selectedLang && this.selectedLang !== LAST_VALUE;
        }
    }
};
</script>

<style scoped lang="scss">
.preferences {
    &-users {
        margin-bottom: 20px;

        & .ligne {
            margin: 5px 0;

            & input {
                border: none;
            }
        }
    }

    &-select {
        & .ligne {
            margin: 15px 0;

            & label {
                width: 170px;
                display: inline-block;
            }

            & select {
                width: 230px;
                display: inline-block;
                background: none;
                padding: 3px 0;
                border-radius: 5px;
                text-transform: uppercase;
                font-size: 13px;

                & option {
                    &.extra-option {
                        font-weight: bold;
                        text-transform: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Preferences.vue?68d40b78